import DateFNS from 'date-fns';
import { convertStringToDate } from '@devesharp/react/web';

export const BOLETO_STATUS = {
   PENDING: 'pending',
   PROCESSING: 'processing',
   EXPIRED: 'expired',
   DUE: 'due',
   PAID: 'paid',
   CANCELLED: 'cancelled',
   NOT_PAID: 'not_paid',
} as const;

const PAID_STATUSES: readonly string[] = [BOLETO_STATUS.PAID, 'over_paid', 'under_paid'];
const CANCELLED_STATUSES: readonly string[] = [BOLETO_STATUS.CANCELLED, 'canceled'];
const OPEN_STATUSES: readonly string[] = [
   BOLETO_STATUS.NOT_PAID,
   BOLETO_STATUS.PENDING,
   BOLETO_STATUS.PROCESSING,
   BOLETO_STATUS.DUE,
];

export function isBoletoPaid(status?: string): boolean {
   return PAID_STATUSES.includes(status ?? '');
}

export function isBoletoCancelled(status?: string): boolean {
   return CANCELLED_STATUSES.includes(status ?? '');
}

export function isBoletoExpired(status?: string): boolean {
   return status === BOLETO_STATUS.EXPIRED;
}

export function isBoletoOpen(status?: string): boolean {
   return OPEN_STATUSES.includes(status ?? '');
}

export function getBoletoStatusPresentation(
   status?: string,
   expirationDate?: string,
   cancel = false,
): { label: string; badgeClass: string } {
   if (cancel || isBoletoCancelled(status)) {
      return { label: 'Cancelado', badgeClass: 'badge-error' };
   }

   if (isBoletoPaid(status)) {
      return { label: 'Pago', badgeClass: 'badge-succeeded' };
   }

   if (isBoletoExpired(status)) {
      return { label: 'Vencido', badgeClass: 'badge-error' };
   }

   if (status === BOLETO_STATUS.PROCESSING) {
      return { label: 'Processando', badgeClass: 'badge-processing' };
   }

   if (status === BOLETO_STATUS.DUE) {
      return { label: 'A vencer', badgeClass: 'pedding' };
   }

   if (status === BOLETO_STATUS.PENDING) {
      return { label: 'Pendente', badgeClass: 'badge-pending' };
   }

   if (status === BOLETO_STATUS.NOT_PAID && expirationDate) {
      const diff = DateFNS.differenceInDays(DateFNS.format(convertStringToDate(expirationDate)), new Date());

      if (diff < 0) {
         return { label: 'Vencido', badgeClass: 'badge-error' };
      }

      return { label: 'A vencer', badgeClass: 'pedding' };
   }

   if (status === 'failed') {
      return { label: 'Falhado', badgeClass: 'badge-failed' };
   }

   return { label: 'Pendente', badgeClass: 'badge-pending' };
}
